import { api } from "../lib/axios";

export const logout = async () => {
  const response = await api.get("/api/v1/users/auth/logout");
  return response.data;
};

export const getLoggedInUser = async () => {
  const response = await api.get(`/api/v1/users/auth/me`);
  return response.data;
};
